import { render, staticRenderFns } from "./WhatsappContactCard.vue?vue&type=template&id=f40a818a&scoped=true"
import script from "./WhatsappContactCard.vue?vue&type=script&lang=js"
export * from "./WhatsappContactCard.vue?vue&type=script&lang=js"
import style0 from "./WhatsappContactCard.vue?vue&type=style&index=0&id=f40a818a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40a818a",
  null
  
)

export default component.exports